import React from 'react'
import { Alert } from 'reactstrap'
import Comments from '@/components/comments/Comments'

class TicketCommentItem extends React.Component {
  render () {
    const { ticketComment, author, onCommentCreated, isAddingComment } = this.props
    return (
      <React.Fragment>
        <div className='TicketCommentItem'>
          <Alert color='dark'>{ticketComment.name}</Alert>
          <Comments
            author={author}
            comments={ticketComment.comments}
            isAddingComment={isAddingComment}
            onCommentCreated={onCommentCreated} />
        </div>
      </React.Fragment>)
  }
}

export default TicketCommentItem



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/comments/ticketCommentItem.js